import { NavLink } from "react-router";
import React from "react";
import styled from "styled-components";
import { INavLink } from "core-integration/src/hooks/types";
import "./ListItem.css";

const LIStyled = styled.li`
  margin-right: ${({ theme }) => theme.space[1]};
  list-style-type: none;
  display: inline-block;
  vertical-align: middle;
`;

const ListItem = React.forwardRef<HTMLLIElement, INavLink>(
  ({ useRouter, text, href, rel, isDraft, target }, ref) => {
    return (
      <LIStyled ref={ref}>
        {useRouter ? (
          <NavLink
            to={href}
            className={({ isActive }) =>
              isActive ? `ism-nav__tab active` : `ism-nav__tab`
            }
          >
            {text}
          </NavLink>
        ) : (
          <a
            href={href}
            className={`ism-nav__tab ${isDraft && "isAlt"}`}
            rel={rel}
            target={target}
          >
            <span>{text}</span>
          </a>
        )}
      </LIStyled>
    );
  },
);

export default ListItem;
